export function setMd(page_id, page_name, page_url) {
  // 基础埋点
  // 阿里巴巴保密信息/ALIBABACONFIDENTIAL 用户信息埋点
  //如采集用户信息是异步行为需要先执行这个BLOCK埋点
  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['_hold', 'BLOCK']
  })
  //单页应用或“单个页面”需异步补充PV日志参数还需进行如下埋点：
  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['aplus-waiting', 'MAN']
  }) //
  //单页应用路由切换后或在异步获取到pv日志所需的参数后再执行sendPV：
  aplus_queue.push({
    action: 'aplus.sendPV',
    arguments: [
      { is_auto: false },
      {
        // 当前应用的实际信息
        sapp_id: '27652',
        sapp_name: 'publish_lcly',
        //自定义PV参数key-value键值对（只能是这种平铺的json，不能做多层嵌套），
        page_id: page_id,
        page_name: page_name,
        page_url: page_url
      }
    ]
  })

  let _user_id = sessionStorage.getItem('accountid') || ''
  // 当前用户ID
  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['_user_id', _user_id] // 当前用户ID，后台获取
  })

  //如采集用户信息是异步行为，需要先设置完用户信息后再执行这个START埋点
  //此时被block住的日志会携带上用户信息逐条发出
  aplus_queue.push({
    action: 'aplus.setMetaInfo',
    arguments: ['_hold', 'START']
  })
}



// WEBPACK FOOTER //
// ./src/utils/maidian/zzdmd.js